<app-generic-header [goBack]="goBack.bind(this)" variant="back">
</app-generic-header>

<ion-content class="ion-padding">

  <div class="badgeContainer">
    <div class="titleBadge">
      <!-- <ion-badge>
        {{ 'signUp' | translate }}
      </ion-badge> -->
    </div>
  </div>

  <div class="imgDiv">
    <img src="assets/imgs/logo_novo.svg" alt="Veggly Logo">
  </div>

  <div class="welcome">
    {{ 'signUp' | translate }}
  </div>

  <div class="formSection">
    <ion-list>
      <div class="fillyourdetails">
        <span> {{ 'enterEmailPassValidationCodeWillBeSent' | translate }}</span>
      </div>
      <form [formGroup]="signupWithEmailForm">
        <ion-item lines="none" class="custom"
          [class.invalid]="!signupWithEmailForm.controls.emailControl.valid && (signupWithEmailForm.controls.emailControl.dirty || submitAttempt)">
          <ion-icon slot="start" name="mail-outline"></ion-icon>
          <ion-input clearInput placeholder="Email" type="email" formControlName="emailControl"></ion-input>
        </ion-item>
        <ion-item class="alert"
          *ngIf="!signupWithEmailForm.controls.emailControl.valid && (signupWithEmailForm.controls.emailControl.dirty || submitAttempt)">
          <p>{{'validEmailMsg' | translate}}</p>
        </ion-item>


        <ion-item lines="none" class="custom"
          [ngClass]="{'invalid': !signupWithEmailForm.controls.userpassControl.valid && (signupWithEmailForm.controls.userpassControl.dirty || submitAttempt)}">
          <ion-icon slot="start" name="lock-closed"></ion-icon>
          <ion-input [type]="show ? 'text' : 'password'" class="custom" placeholder="{{'password' | translate}}"
            type="password" formControlName="userpassControl"></ion-input>
          <ion-icon (click)="password()" slot="end" [name]="show ? 'eye' : 'eye-off-outline'"
            aria-hidden="true"></ion-icon>
        </ion-item>

        <ion-item class="alert"
          *ngIf="!signupWithEmailForm.controls.userpassControl.valid && (signupWithEmailForm.controls.userpassControl.dirty || submitAttempt)">
          <p>{{'validPasswordMsg' | translate}}</p>

        </ion-item>

        <ion-item lines="none" class="custom"
          [ngClass]="{'invalid': !signupWithEmailForm.controls.reenterpassControl.valid && (signupWithEmailForm.controls.reenterpassControl.dirty || submitAttempt)}">
          <ion-icon slot="start" name="lock-closed"></ion-icon>
          <ion-input [type]="show ? 'text' : 'password'" class="custom" placeholder="{{'reenterPassword' | translate}}"
            type="password" formControlName="reenterpassControl"></ion-input>
          <ion-icon (click)="password()" slot="end" [name]="show ? 'eye' : 'eye-off-outline'"
            aria-hidden="true"></ion-icon>
        </ion-item>

        <ion-item class="alert"
          *ngIf="!signupWithEmailForm.controls.reenterpassControl.valid && (signupWithEmailForm.controls.reenterpassControl.dirty || submitAttempt)">
          <p>{{'reenterValidPassword' | translate}}</p>
        </ion-item>

      </form>
    </ion-list>
  </div>

  <!-- <div class="bottomButtons">
    <ion-button expand="full" class="buttonShadow" color="primary" shape="round" fill="solid" (click)="signMeUp()">
      {{ 'signMeUp' | translate }}
    </ion-button>
    <ion-button expand="full" color="primary" class="buttonShadow" shape="round" fill="outline" (click)="alreadyHaveValCode()">
      {{ 'alreadyHaveValidationCode' | translate }}
    </ion-button>
  </div> -->

  <div class="bottomButtons">
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-button expand="full" class="buttonShadow" color="primary" shape="round" fill="solid"
            (click)="signMeUp()">
            {{ 'signMeUp' | translate }}
          </ion-button>
        </ion-col>
        <!-- <ion-col size="6">
          <ion-button  (click)="goToForgotPasswordPage()" class="buttonShadow" expand="full" color="primary"  shape="round" fill="outline" >{{'forgotPassword' | translate}}</ion-button>
        </ion-col> -->
      </ion-row>
    </ion-grid>

    <div class="control-social-login">
      <div class="divider">
        <span>{{ 'or' | translate }}</span>
      </div>
      <p class="social-hint">{{ 'continueWithSocialHint' | translate }}</p>
      <div class="featureButtons">
        <div class="circleButtonWrapper">
          <ion-button (click)="continueWithSocial('google')">
            <div class="featureIcons">
              <img src="assets/imgs/icons/google-icon.svg" alt="Google" />
            </div>
          </ion-button>
        </div>
        <div class="circleButtonWrapper">
          <ion-button (click)="continueWithSocial('facebook')">
            <div class="featureIcons">
              <img src="assets/imgs/icons/facebook-icon.svg" alt="Facebook" />
            </div>
          </ion-button>
        </div>
        <div class="circleButtonWrapper" *ngIf="isIosNative">
          <ion-button (click)="continueWithSocial('apple')">
            <div class="featureIcons">
              <img src="assets/imgs/icons/apple-icon.svg" alt="Apple" />
            </div>
          </ion-button>
        </div>
      </div>
    </div>

    <ion-grid>
      <ion-row>
        <ion-col>
          <div class="notAUserBtn" (click)="alreadyHaveValCode()">
            <span class="validation-text">{{ 'alreadyHaveValidationCode' | translate }}</span>
          </div>
        </ion-col>
        <!-- <ion-col size="6">
          <ion-button  (click)="goToForgotPasswordPage()" class="buttonShadow" expand="full" color="primary"  shape="round" fill="outline" >{{'forgotPassword' | translate}}</ion-button>
        </ion-col> -->
      </ion-row>
    </ion-grid>



  </div>

</ion-content>